import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'deo-ai-assistant-rename-chat',
  standalone: false,
  templateUrl: './deo-ai-assistant-rename-chat.component.html',
  styleUrls: ['./deo-ai-assistant-rename-chat.component.scss']
})
export class DeoAiAssistantRenameChatComponent {
  formGroup: FormGroup = new FormGroup({
    chatName: new FormControl('', Validators.required)
  });
  modalTitle = 'Rename Chat';

  constructor(
    @Inject(NZ_MODAL_DATA) private readonly data: { sessionId: string; originalChatName: string },
    private readonly _modalRef: NzModalRef
  ) {
    this.formGroup.setValue({
      chatName: data.originalChatName
    });
  }
  onCancel(): void {
    this._modalRef.destroy();
  }

  onSave(): void {
    if (!this.formGroup.valid) {
      this.formGroup.markAllAsTouched();
      return;
    }
    const chatName = (this.formGroup.value?.chatName ?? '').trim();
    this._modalRef.close({
      sessionId: this.data.sessionId,
      newChatName: chatName
    });
  }
}
